import { useState, useCallback } from 'react';
import { n211Api, FN210 } from '../../../services/n211Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for a master record */
  const resolveAllNames = useCallback(async (data: Partial<FN210>) => {
    const entries: [string, string, string][] = [
      ['vendor', 'vendor', data.fn210_12 || ''],
      ['currency', 'currency', data.fn210_13 || ''],
      ['warehouse', 'warehouse', data.fn210_23 || ''],
      ['department', 'department', data.fn210_16 || ''],
      ['employee', 'employee', data.fn210_15 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        n211Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await n211Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
